













import Popup from '@/views/organisms/Popup.vue'
import ApiClient from '@/common/api'
import store from '@/store'
import BlueButton from '@/views/atoms/BlueButton.vue'

export default
  components: {
    Popup
    BlueButton
  }

  data: () ->
    disabled: false

  props:
    title:
      type: String
      default: '削除してよろしいですか？'
    isCancel:
      type: Boolean
      defalt: false

  methods: {
    close_popup: (e) ->
      @$emit('close_popup')
    send: () ->
      @disabled = true
      @$emit('send')
  }
